import Vue from "vue";

let vue = new Vue();

export function axiosApi(api, param, query) {
  let NULL = null;
  return vue
    .$http({
      url: api.url,
      method: api.method,
      data: param,
      params: query,
      timeout: 1000 * 120,
    })
    .then(data => {
      return { data: data, err: NULL };
    })
    .catch(err => {
      return { data: NULL, err };
    });
}



// WEBPACK FOOTER //
// ./src/common/js/api.js